import { render } from "./zjzl.vue?vue&type=template&id=0d497afa&scoped=true&ts=true"
import script from "./zjzl.vue?vue&type=script&lang=ts"
export * from "./zjzl.vue?vue&type=script&lang=ts"

import "./zjzl.vue?vue&type=style&index=0&id=0d497afa&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d497afa"]])

export default __exports__